var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Widget',{attrs:{"title":_vm.title,"loading":_vm.loading}},[_c(_vm.chartComponent,{tag:"component",attrs:{"data":_vm.data,"loading":_vm.loading,"legend":_vm.legend}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }